module.exports = __webpack_public_path__ + "arabesque3.dc03ca29bc97989f7210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme/arabesque3.png
// module id = 638
// module chunks = 1